module.exports = __webpack_public_path__ + "static/media/fig_13d2.17f5e251.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13d2.jpg
// module id = 639
// module chunks = 0